import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricHotelAverageLeadValueMicrosRate extends MetricBase {
    constructor() {
        super({
            field: "metric_hotel_average_lead_value_micros",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.hotelAverageLeadValueMicrosRate.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.hotelAverageLeadValueMicrosRate.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.hotelAverageLeadValueMicrosRate.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricHotelAverageLeadValueMicrosRate;
